import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon", "pictureUrl", "shady"];
import React from 'react';
import CircleImage from 'components/CircleImage';
import AssetIcon from 'components/AssetIcon';
import AvatarDot from './AvatarDot';
var Avatar = function Avatar(_ref) {
  var _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'user' : _ref$icon,
    pictureUrl = _ref.pictureUrl,
    shady = _ref.shady,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  if (pictureUrl) {
    return /*#__PURE__*/React.createElement(CircleImage, _extends({}, otherProps, {
      src: pictureUrl
    }));
  }
  return /*#__PURE__*/React.createElement(AssetIcon, _extends({}, otherProps, {
    shady: shady,
    name: icon
  }));
};
export { AvatarDot };
export default Avatar;